import React, { useState, useEffect } from "react";
import styles from "../Styles/ListOfTemplates.module.css";
import { useSelector, useDispatch } from "react-redux";
import { FiTrash2, FiFileText } from "react-icons/fi";
import { FaSearch } from "react-icons/fa";
import { fetchTemplates, deleteTemplate } from "../../../actions/saveTemplate";
import { AppSidebar } from "./sidebar";
import Header from "../../header";
import { Link } from "react-router-dom";
import { decryptData } from "../../utils/EncriptionStore";

const TemplateItem = ({ template }) => {
  const dispatch = useDispatch();
  const user = (() => {
    const encryptedData = localStorage.getItem("profile");
    return encryptedData ? decryptData(encryptedData) : null;
  })();


const handleDelete = () => {
  dispatch(
    deleteTemplate({
      name: template, // 👈 backend expects `name`, not `template`
      customer_id: user?.customer_id,
      group_id: user?.group_id,
      customer_name: user?.customer_name,
      group_name: user?.groupname,
    })
  );
};


  return (
    <div className={styles.templateItem}>
      <Link
        to={`/inventory_detail?inventory_name=${template}`}
        className={styles.templateLink}
        title={`View details of ${template}`}
      >
        <FiFileText className={styles.templateIcon} />
        <span className={styles.templateName}>{template}</span>
      </Link>

      <div className={styles.actions}>
        <button
          onClick={handleDelete}
          className={styles.deleteButton}
          title="Delete Template"
        >
          <FiTrash2 />
        </button>
      </div>
    </div>
  );
};

const ListOfTemplates = () => {
  const user = (() => {
    const encryptedData = localStorage.getItem("profile");
    return encryptedData ? decryptData(encryptedData) : null;
  })();
  const dispatch = useDispatch();
  const templates = useSelector((state) => state.saveTemplate.templates);
  const [isOpen, setIsOpen] = useState(true);
  const [userQuery, setUserQuery] = useState("");

  const [currentPage, setCurrentPage] = useState(1);

  const templatesPerPage = 5;

  useEffect(() => {
    dispatch(
      fetchTemplates()
    );
  }, [dispatch]);

  useEffect(() => {
    setCurrentPage(1);
  }, [userQuery]);

  const toggleSidebar = () => setIsOpen((prev) => !prev);

  const handleSearch = (e) => {
    setUserQuery(e.target.value);
  };

  const filteredTemplates = Array.isArray(templates)
    ? templates.filter((template) =>
      template.toLowerCase().includes(userQuery.toLowerCase())
    )
    : [];

  const totalPages = Math.ceil(filteredTemplates.length / templatesPerPage);

  const indexOfLastTemplate = currentPage * templatesPerPage;
  const indexOfFirstTemplate = indexOfLastTemplate - templatesPerPage;
  const paginatedTemplates = filteredTemplates.slice(
    indexOfFirstTemplate,
    indexOfLastTemplate
  );

  const Pagination = () => (
    <div className={styles.pagination}>
      <button
        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        disabled={currentPage === 1}
      >
        Prev
      </button>
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i}
          onClick={() => setCurrentPage(i + 1)}
          className={currentPage === i + 1 ? styles.activePage : ""}
        >
          {i + 1}
        </button>
      ))}
      <button
        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
        disabled={currentPage === totalPages}
      >
        Next
      </button>
    </div>
  );

  return (
    <div className={styles.listContainer}>
      <div className={styles.twoSidebars}>
        <Header />
        <div
          className={` ${isOpen ? styles.sidebarOpen : styles.sidebarClosed}`}
        >
          <AppSidebar isOpen={isOpen} toggleSidebar={toggleSidebar} />
        </div>
      </div>

      <div className={`${styles.dashboardLayout} `}>
        <div className={styles.listOfTemplatesHeader}>
          <h2>List of Inventories</h2>
          <div className={styles.listOfTemplatesSearchContainer}>
            <span className={styles.listOfTemplatesSearchIcon}>
              <FaSearch />
            </span>
            <input
              type="text"
              value={userQuery}
              onChange={handleSearch}
              placeholder="Search Inventories..."
              className={styles.listOfTemplatesSearchInput}
            />
          </div>
        </div>
        <div className={styles.listofTemplatesListContainer}>
          {paginatedTemplates?.length > 0 ? (
            paginatedTemplates.map((template) => (
              <TemplateItem key={template} template={template} />
            ))
          ) : (
            <p className={styles.emptyState}>No Templates Available</p>
          )}
        </div>
        {templates.length > templatesPerPage && <Pagination />}
      </div>
    </div>
  );
};

export default ListOfTemplates;
